import FormConfigurator from '../components/fieldtypes/FormConfigurator.vue';
import { Hyphenate } from './HyphenateMark';
 
// Should be named [snake_case_handle]-fieldtype
Statamic.$components.register('form_configurator-fieldtype', FormConfigurator);

Statamic.booting(() => {
    Statamic.$bard.addExtension(() => Hyphenate);

    Statamic.$bard.buttons((buttons, button) => {
        const hyphenateButtonIndex = _.findIndex(buttons, (btn) => btn === 'hyphenate');

        buttons.splice(hyphenateButtonIndex + 1, 0, button({
            name: 'hyphenate',
            text: 'Wort umbrechen (wenn nötig)',
            command: (editor) => editor.commands.setHyphenation(),
            html: `<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="currentColor" class="bi bi-text-wrap" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M2 3.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5Zm0 4a.5.5 0 0 1 .5-.5h9a2.5 2.5 0 0 1 0 5h-1.293l.647.646a.5.5 0 0 1-.708.708l-1.5-1.5a.5.5 0 0 1 0-.708l1.5-1.5a.5.5 0 0 1 .708.708l-.647.646H11.5a1.5 1.5 0 0 0 0-3h-9a.5.5 0 0 1-.5-.5Zm0 4a.5.5 0 0 1 .5-.5H7a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1-.5-.5Z"/>
            </svg>`
        }));
    });
});